import { useState, useEffect, useMemo, useContext } from 'react';
import { AppContext } from '../../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { createColumnHelper } from '@tanstack/react-table';
import DataTable from '../../../component/wallet/data-table/DataTable';
import StatusBadge from '../../../component/wallet/StatusBadge';
import CurrencyDisplay from '../../../component/wallet/CurrencyDisplay';
import { useWallets } from '../../../Hooks/wallet/usewallets';
import { formatDate } from '../../../lib/wallet/utils';

const columnHelper = createColumnHelper();

const WalletsPage = () => {
    const { sidebar } = useContext(AppContext);
    const navigate = useNavigate();
    const { loading, fetchWallets } = useWallets();
    const [wallets, setWallets] = useState([]);

    useEffect(() => {
        const load = async () => {
            try {
                const res = await fetchWallets();
                setWallets(res?.data || []);
            } catch {
                // handled
            }
        };
        load();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const columns = useMemo(
        () => [
            columnHelper.accessor('id', { header: 'ID', size: 60 }),
            columnHelper.accessor('currency_code', {
                header: 'Currency',
                cell: (info) => (
                    <span>
                        {info.row.original.currency_symbol} {info.getValue()} — {info.row.original.currency_name}
                    </span>
                ),
            }),
            columnHelper.accessor('wallet_type', {
                header: 'Type',
                cell: (info) => <StatusBadge status={info.getValue()} />,
            }),
            columnHelper.accessor('balance', {
                header: 'Balance',
                cell: (info) => (
                    <CurrencyDisplay
                        amount={info.getValue()}
                        currencyCode={info.row.original.currency_code}
                        currencySymbol={info.row.original.currency_symbol}
                    />
                ),
            }),
            columnHelper.accessor('is_active', {
                header: 'Status',
                cell: (info) => (
                    <StatusBadge status={info.getValue() ? 'active' : 'inactive'} />
                ),
            }),
            columnHelper.accessor('expires_at', {
                header: 'Expires At',
                cell: (info) => (info.getValue() ? formatDate(info.getValue(), 'MMM dd, yyyy') : '—'),
            }),
        ],
        []
    );

    return (
        <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
            <div className="role-content-main">
            <div className="sub-header-role mb-4">
                <h6 className="mt-2 role-text">My Wallets</h6>
            </div>
                <div className="fade-in">
            
            <DataTable
                columns={columns}
                data={wallets}
                loading={loading}
                emptyTitle="No wallets"
                emptyDescription="You don't have any wallets yet."
                onRowClick={(row) => navigate(`/user/transactions?wallet_id=${row.id}`)}
            />
        </div>
        </div>
        </div>
    );
};

export default WalletsPage;
